/**
 * @desc 导出库位库存
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.stockPool.exportStockDetail.Params, options?: any) {
  return updateResponse(
    http(URL + `/stockPool/exportStockDetail`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
